export class Spring {
  USUSUARI = 'Ususuari/';
  SIGNIN_TOKEN = 'signin';
  REFRESH_TOKEN = 'refreshtoken';
  SIGNOUT_TOKEN = 'signout';
  LOGIN_MICROSOFT = 'loginMicrosoft';
  RESET_MICROSOFT = 'resetMicrosoft';

  // Utilerias
  UTILERIAS_CURDATE = 'Utilerias/getDBCurdate/';


  // TABLA USUSUARI
  USUSUARI_GET_DEPARTAMENTO_USUARIO_TOKEN = 'Ususuari/getDepartamentoEmpleadoToken/';
  USUSUARI_GET_DESCRIPCION_DEPARTAMENTO_USUARIO_BY_IDUSUARI = 'Ususuari/getDescripcionDepartamentoEmpleadoByIdusuari/';
  USUSUARI_GET_LIST_USUARIOS_AUTORIZAN_VACACIONES = 'Ususuari/getListUsuariosAutorizanVacaciones/';
  USUSUARI_GET_LIST_USUSARIOS_VACACIONES = 'Ususuari/getListUsuarioVacaciones/';
  USUSUARI_GET_NOMBRE_USUARIO = 'Ususuari/getNombreUsuario/';
  USUSUARI_GET_USUARIOS_VACACIONES_GENERALES = 'Ususuari/getListUsuariosVacacionesGenerales/';
  USUSUARI_GET_LIST = 'Ususuari/getListUsusuari';
  USUSUARI_GET_CELEBRACIONES = 'Ususuari/getCelebraciones'
  USUSUARI_CAMBIAR_PASSWORD = 'Ususuari/cambiarPassword/';
  USUSUARI_RESET_PASSWORD = 'Ususuari/resetPassword';
  USUSUARI_GET_AVATAR = 'Ususuari/getFotoUsuario';
  USUSUARI_GET_LIST_DETAILS = 'Ususuari/getListUsusuariDetails';

  // TABLA UVVACACI
  UVVACACI_CANCELAR_VACACIONES = 'Uvvacaci/cancelarVacaciones/';
  UVVACACI_ENVIAR_AUTORIZACION_RH_VACACIONES = 'Uvvacaci/enviarAutorizacionRhVacaciones/'
  UVVACACI_ENVIAR_AUTORIZACION_VACACIONES = 'Uvvacaci/enviarAutorizacionVacaciones/'
  UVVACACI_ENVIAR_VACACIONES = 'Uvvacaci/enviarVacaciones/';
  UVVACACI_GET_DETALLE_VACACIONES = 'Uvvacaci/getDetalleVacaciones/'
  UVVACACI_GET_IDUSUARI_AUTORIZA_VACACIONES = 'Uvvacaci/getIdusuariAutorizaVacaciones/';
  UVVACACI_GET_INFORMACION_FIRMAS_VACACIONES = 'Uvvacaci/getInformacionFirmasVacaciones/';
  UVVACACI_GET_TABLA_CALENDARIO = 'Uvvacaci/getTablaCalendario/';
  UVVACACI_INSERT_VACACIONES = 'Uvvacaci/insertVacaciones/';
  UVVACACI_LIST_VACACIONES_EMPLEADO = 'Uvvacaci/getListVacacionesEmpleado/';
  UVVACACI_PRINT_VACACIONES = 'Uvvacaci/printVacaciones/'
  UVVACACI_SAVE_VACACIONES = 'Uvvacaci/saveVacaciones/';
  UVVACACI_UPDATE_VACACIONES = 'Uvvacaci/updateVacaciones/';
  UVVACACI_VACACIONES_POPOVER = 'Uvvacaci/getVacacionesPopover/';
  UVVACACI_VERIFICAR_PERMISO_CANCELACION = 'Uvvacaci/verificarPermisoCancelacion/';
  UVVACACI_AGREGAR_VACACIONES_GENERALES = 'Uvvacaci/agregarVacacionesGenerales/'
  UVVACACI_VERIFICAR_PERMISO_VACACIONES_GENERALES = 'Uvvacaci/verificarPermisoVacacionesGenerales/';
  UVVACACI_GET_VACACIONES_SIN_APROBAR = 'Uvvacaci/vacacionesSinAprobar/'

  // TABLA UVCONDI
  UVCONDIC_GET_LIST_UVCONDIC = 'Uvcondic/getListUvcondic/';

  // TABLA UVMOTIVO
  UVMOTIVO_GET_LIST_UVMOTIVO = 'Uvmotivo/getListUvmotivo/';

  // TABLA GLMONEDA
  GLMONEDA_GET_LIST = 'Glmoneda/getListGlmoneda';

  // TABLA UVPERMIS
  UVPERMIS_AUTORIZAR_PERMISO = 'Uvpermis/autorizarPermiso/';
  UVPERMIS_CANCELAR_PERMISO = 'Uvpermis/cancelarPermiso/';
  UVPERMIS_ENVIAR_PERMISO = 'Uvpermis/enviarPermiso/';
  UVPERMIS_GET_INFORMACION_PERMISO_POPOVER = 'Uvpermis/getInformacionPermisoPopover/';
  UVPERMIS_GET_LIST_PERMISOS = 'Uvpermis/getListPermisos/';
  UVPERMIS_SAVE_PERMISO = 'Uvpermis/savePermiso/';
  UVPERMIS_GET_PERMISOS_SIN_APROBAR = 'Uvpermis/permiSinAprobar/';
  UVPERMIS_PERMISO_MULTIPLE = 'Uvpermis/permisoMultiple';
  UVPERMIS_PRINT_PERMISO = 'Uvpermis/printPermisos/';
  UVPERMIS_GET_RESUMENTXT = 'Uvpermis/getResumenTxT';


  // TABLA SAREGFIS
  SAREGFIS_GET_LIST = 'Saregfis/getListSaregfis';

  // TABLA GLNACION
  GLNACION = 'Glnacion';
  GLNACION_GET_LIST = 'Glnacion/getListGlnacion';
  GLNACION_GET_DATA_LIST = 'Glnacion/getDataList'

  // TABLA GLBANCOS
  GLBANCOS = 'Glbancos';
  GLBANCOS_GET_LIST = 'Glbancos/getListGlbancos';
  GLBANCOS_GET_DATA_LIST = 'Glbancos/getDataList';

  // TABLA GLTIPDOM
  GLTIPDOM_GET_LIST = 'Gltipdom/getListGltipdom';

  // TABLA CTESTATU
  CTESTATU_GET_LIST = 'Ctestatu/getListCtestatu';

  // TABLA GLTIPPOL
  GLTIPPOL_GET_LIST = 'Gltippol/getListGltippol';

  // TABLA GLTIPCLA
  GLTIPCLA_GET_LIST = 'Gltipcla/getListGltipcla';

  // TABLA CTPERPLA
  CTPERPLA_GET_LIST = 'Ctperpla/getListCtperpla';

  // TABLA GLTIPPER
  GLTIPPER_GET_LIST = 'Gltipper/getListGltipper';

  // TABLA GLTIPINT
  GLTIPINT_GET_LIST = 'Gltipint/getListGltipint';

  // TABLA PVTIPPRO
  PVTIPPRO_GET_LIST = 'Pvtippro/getListPvtippro';

  // TABLA PVTIPCON
  PVTIPCON_GET_LIST = 'Pvtipcon/getListPvtipcon';

  // TABLA CTCONDIC
  CTCONDIC = 'Ctcondic';
  CTCONIDC_GET_LIST_BY_IDPATINM = 'Ctcondic/getListCtcondiciByIdpatinm/';
  CTCONIDC_NUM_BY_IDPATINM_ACTIVAS = 'Ctcondic/getNumeroCtcondicByIdpatinmActivas/';

  // TABLA CTCONTRA
  CTCONTRA = 'Ctcontra';
  CTCONTRA_GET_LIST_BY_IDCONDIC = 'Ctcontra/getListCtcontraByIdcondic/';
  CTCONTRA_NUM_BY_IDCONDIC_ACTIVAS = 'Ctcontra/getNumeroCtcontraByIdcondicActivas/';

  // TABLA CTCONVEN
  CTCONVEN = 'Ctconven';
  CTCONVEN_GET_LIST_BY_IDCONTRA = 'Ctconven/getListCtconvenByIdcontra/';
  CTCONVEN_COUNT_BY_IDCONTRA = 'Ctconven/getNumeroConveniosByIdcontra/';

  // TABLA CTCONFAC
  CTCONFAC = 'Ctconfac';
  CTCONFAC_GET_LIST_BY_IDCONTRA = 'Ctconfac/getListCtconfacByIdcontra/';
  CTCONFAC_GET_NUMERO_BY_IDCONTRA_VIGENTES = 'Ctconfac/getNumeroCtconfacByIdcontraVigentes/';

  // TABLA GLTIPADJ
  GLTIPADJ_GET_LIST_BY_TABLA = 'Gltipadj/getComboDTOBytabla/';
  GLTIPADJ_GET_LIST = 'Gltipadj/getListGltipadj/';
  GLTIPADJ_GET_LIST_BY_INPATRIM = 'Gltipadj/getListGltipadjByInpatrim/';
  GLTIPADJ_GET_LIST_BY_INPATINM = 'Gltipadj/getListGltipadjByInpatinm/';
  GLTIPADJ_GET_LIST_BY_PREPAGOS = 'Gltipadj/getListGltipadjByPrepagos/';
  GLTIPADJ_GET_LIST_BY_CTCONTRA = 'Gltipadj/getListGltipadjByCtcontra/';
  GLTIPADJ_GET_LIST_BY_CTCONVEN = 'Gltipadj/getListGltipadjByCtconven/';
  GLTIPADJ_GET_LIST_BY_INSEGURO = 'Gltipadj/getListGltipadjByInseguro';
  GLTIPADJ_GET_LIST_BY_INSEGURO_PAGOS = 'Gltipadj/getListGltipadjByInseguroPagos/';
  GLTIPADJ_GET_LIST_BY_LILICENC = 'Gltipadj/getListGltipadjByLilicenc';
  GLTIPADJ_GET_LIST_BY_RQGENRAL = 'Gltipadj/getListGltipadjByRqgenral';
  GLTIPADJ_GET_LIST_BY_CPMOVIMI = 'Gltipadj/getListGltipadjByCpmovimi/';
  GLTIPADJ_GET_LIST_BY_CGGASDET = 'Gltipadj/getListGltipadjByCggasdet/';
  GLTIPADJ_GET_LIST_BY_LEACUSES = 'Gltipadj/getListGltipadjByLeacuses/';
  GLTIPADJ_GET_LIST_BY_PSINFGEN = 'Gltipadj/getListGltipadjByPsinfgen';

  // TABLA SAUSOCFD
  SAUSOCFD = 'Sausocfd';
  SAUSOCFD_GET_LIST = 'Sausocfd/getListSausocfd';
  SAUSOCFD_GET_DATA_LIST = 'Sausocfd/getDataList';

  // TABLA SAFORPAG
  SAFORPAG = 'Saforpag';
  SAFORPAG_GET_LIST = 'Saforpag/getListSaforpag';
  SAFORPAG_GET_LIST_CXP = 'Saforpag/getListSaforpagCXP';
  SAFORPAG_GET_DATA_LIST = 'Saforpag/getDataList';

  // TABLA SAMETPAG
  SAMETPAG = 'Sametpag';
  SAMETPAG_GET_LIST = 'Sametpag/getListSametpag';
  SAMETPAG_GET_DATA_LIST = 'Sametpag/getDataList'

  // TABLA GLTIPMON
  GLTIPMON = 'Gltipmon';
  GLTIPMON_GET_LIST = 'Gltipmon/getListGltipmon';
  GLTIPMON_BY_ID = 'Gltipmon/getGltipmonById/';
  GLTIPMON_GET_DATA_LIST = 'Gltipmon/getDataList';

  // TABLA GLARREND
  GLARREND_GET_LIST = 'Glarrend/getListGlarrend';

  // TABLA GLPARCIA
  GLPARCIA_GET_LIST = 'Glparcia/getListGlparcia';

  // TABLA GLMOVCON
  GLMOVCON_GET_LIST = 'Glmovcon/getListGlmovcon';

  // TABLA SATIPEXP
  SATIPEXP_GET_LIST = 'Satipexp/getListSatipexp';

  // TABLA SATIPCOM
  SATIPCOM_GET_LIST = 'Satipcom/getListSatipcom';
  SATIPCOM_GET_LIST_GENERAL = 'Satipcom/getListSatipcomGeneral';

  // TABLA SAPROSER
  SAPROSER = 'Saproser';
  SAPROSER_GET_LIST = 'Saproser/getListSaproser';
  SAPROSER_GET_DATA_LIST = 'Saproser/getDataList';

  // TABLA SAPROARO
  SAPROARO_SAVE = 'Saproaro/saveClave/';
  SAPROARO_GET_LIST_BY_TRANSPORTE = 'Saproaro/getListSaproaroByTransporte';
  SAPROARO_GET_LIST_BY_ALIMENTOS = 'Saproaro/getListSaproaroByAlimentos';
  SAPROARO_GET_LIST_BY_HOTEL = 'Saproaro/getListSaproaroByHotel';

  // TABLA SAUNIMED
  SAUNIMED = 'Saunimed';
  SAUNIMED_GET_LIST = 'Saunimed/getListSaunimed';
  SAUNIMED_GET_DATA_LIST = 'Saunimed/getDataList';

  // TABLA SAOBJIMP
  SAOBJIMP_GET_LIST = 'Saobjimp/getListSaobjimp';

  // TABLA SATIPFAC
  SATIPFAC_GET_LIST = 'Satipfac/getListSatipfac';

  // TABLA SATIPREL
  SATIPREL_GET_LIST = 'Satiprel/getListSatiprel';

  // TABLA GLASENTA
  GLASENTA = 'Glasenta';
  GLSENTA_GET_LIST_BY_CP = 'Glasenta/getListGlasentaByCodigoPostal/';
  GLSENTA_GET_LIST_BY_ID = 'Glasenta/getGlasentaById/';
  GLASENTA_GET_DATA_LIST = 'Glasenta/getDataList';

  // TABLA GLTCD
  GLTCD = 'Gltcd';
  GLTCD_GET_TIPO_CAMBIO = 'Gltcd/getTipoCambio/';
  GLTCD_LIST = 'Gltcd/getListGltcd';
  GLTCD_DELETE = 'Gltcd/deleteGltcd/';
  GLTCD_GET_FECHA_ACTUAL = 'Gltcd/getGltcdFechaActual';
  GLTCD_GET_FECHA_DEFINIDA_DESCRIPCION = 'Gltcd/getTipoCambioDescripcion/';
  GLTCD_GET_LIST_BY_MES_ANIO = 'Gltcd/getGltcdByMesAnio/';

  // TABLA PSPERSON
  PSPERSON = 'Psperson';
  PSPERSON_BY_ID = 'Psperson/getPspersonById/';
  PSPERSON_BY_ID_DETALLE = 'Psperson/getPspersonByIdDetalle/';
  PSPERSON_VALIDAR_RFC = 'Psperson/validarRFC/';
  PSPERSON_GET_LIST_NO_PROPIETARIOS = 'Psperson/getListPspersonNoPropietarios/';
  PSPERSON_GET_LIST_PROPIETARIOS = 'Psperson/getListPspersonPropietarios';
  PSPERSON_GET_LIST_NO_PSPERCLI = 'Psperson/getListPspersonNoPspercli/';
  PSPERSON_GET_LIST_IS_PSTERCER = 'Psperson/getListPspersonIsPstercer/';
  PSPERSON_GET_LIST_NO_CTCONPER = 'Psperson/getListPspersonNoCtconper/';
  PSPERSON_GET_LIST_NO_INPATPRO = 'Psperson/getListPspersonNoInpatpro/';
  PSPERSON_GET_LIST_BY_USUARIOFD = 'Psperson/getListPspersonByUsuarioFD';
  PSPERSON_GET_LIST_HAS_RFFACTUR = 'Psperson/getListPspersonHasRffactur';
  PSPERSON_GET_LIST_GENERAL = 'Psperson/getListPspersonGeneral';
  PSPERSON_VALIDA_EXPEDIENTE_PLD = 'Psperson/validaExpedientePLD/';

  // TABLA PSPERCLI
  PSPERCLI = 'Pspercli';
  PSPERCLI_BY_IDPERSON_LOCAL = 'Pspercli/getListPspercliByIdperson/';
  PSPERCLI_GET_LIST_BY_PERSON_LOCAL_HAS_RFFACTUR = 'Pspercli/getListPspercliByIdPersonLocalHasRffactur/';
  PSPERCLI_DELETE = 'Pspercli/deletePspercli/';
  PSPERCLI_GET_LIST_BY_PSPERSON_LOCAL = 'Pspercli/getListPspercliByIdPersonLocal/';

  // TABLA PSTERCER
  PSTERCER = 'Pstercer';
  PSTERCER_BY_IDPERSON = 'Pstercer/getListPstercerByIdperson/';
  PSTERCER_DELETE = 'Pstercer/deletePstercer/';
  PSTERCER_BENEFICIARIOS_BY_IDPERSON = 'Pstercer/getListPstercerBeneficiariosByIdperson/';
  PSTERCER_BY_IDTERCER = 'Pstercer/getPstercerByIdtercer/';

  // TABLA PSINFGEN
  PSINFGEN = 'Psinfgen';
  PSINFGEN_GET_LIST_BY_IDPERSON = 'Psinfgen/getListPsinfgenByIdperson/';
  PSINFGEN_BY_ID = 'Psinfgen/getPsinfgenById/';
  PSINFGEN_GET_PDF = 'Psinfgen/getPdf/';

  // TABLA ININMCLI
  ININMCLI = 'Ininmcli';
  ININMCLI_GET_LIST_BY_IDPATINM = 'Ininmcli/getListIninmcliByIdpatrim/';
  ININMCLI_DELETE = 'Ininmcli/deleteIninmcli/';

  // TABLA PSCONTAC
  PSCONTAC = 'Pscontac';
  PSCONTAC_GET_LIST_BY_IDPERSON = 'Pscontac/getListPscontacByIdperson/';
  PSCONTAC_BY_ID = 'Pscontac/getPscontacById/';
  PSCONTAC_GET_LIST_BY_IDPERSON_ENVIOFACTURS = 'Pscontac/getListPscontacByIdpersonEnvioFacturas/';
  PSCONTAC_GET_LIST_BY_IDPERSON_ENVIOPAGOS = 'Pscontac/getListPscontacByIdpersonEnvioPagos/';

  // TABLA PSCTABAN
  PSCTABAN = 'Psctaban';
  PSCTABAN_BY_ID = 'Psctaban/getPsctabanById/';
  PSCTABAN_GET_LIST_BY_IDPERSON = 'Psctaban/getListPsctabanByIdperson/';
  PSCTABAN_GET_LIST_BY_IDPERSON_IDTIPMON = 'Psctaban/getListPsctabanByIdtipmonIdperson/';

  // TABLA PSDOMICI
  PSDOMICI = 'Psdomici';
  PSDOMICI_GET_LIST_BY_IDPERSON = 'Psdomici/getListPsdomiciByIdperson/';
  PSDOMICI_BY_ID = 'Psdomici/getPsdomiciById/';
  PSDOMICI_FACTURACION_GET_LIST_BY_IDPERSON = 'Psdomici/getListPsdomiciFacturacionByIdperson/';
  PSCOMICI_GET_LIST_BY_IDPERSON_ISPROPIETARIO = 'Psdomici/getPsdomiciByIdPersonIsPropietario/';

  // TABLA PSADJUNT
  PSADJUNT_GET_LIST = 'Psadjunt/getListPsadjunt/';
  PSADJUNT_GET_LIST_BY_IDSEGURO_PAGOS = 'Psadjunt/getListPsadjuntByIdseguroPagos/';
  PSADJUNT_GET_LIST_BY_IDGENRAL = 'Psadjunt/getListPsadjuntByIdgenral/';
  PSADJUNT_GET_LIST_BY_IDGASDET = 'Psadjunt/getListPsadjuntByIdgasdet/';
  PSADJUNT_ARCHIVO = 'Psadjunt/getArchivo/';
  PSADJUNT_DELETE = 'Psadjunt/deletePsadjunt/';
  PSADJUNT_EXISTE_COMPROBANTE_CXP = 'Psadjunt/existeComprobante/';

  // TABLA RFFACTUR
  RFFACTUR = 'Rffactur';
  RFFACTUR_XML = 'Rffactur/lecturaXML/';
  RFFACTUR_FILTER = 'Rffactur/filterRffactur/';
  RFFACTUR_GET_LIST_BY_FOLIO_UUID = 'Rffactur/getListRffacturByFolioUuid/';
  RFFACTUR_GET_LIST_GENERAL = 'Rffactur/getListRffacturGeneral';
  RFFACTUR_GET_BY_IDFACTUR = 'Rffactur/getByIdfactur/';
  RFFACTUR_GET_BY_IDFACTUR_LIST_RFFACDET_SIN_IMPUESTO = 'Rffactur/getListRffacdetSinImpuesto/';
  RFFACTUR_GET_BY_IDFACTUR_LIST_RFFACDET_CON_IMPUESTO = 'Rffactur/getListRffacdetConImpuesto/';
  RFFACTUR_GET_LIST_SALDO_PENDIENTE = 'Rffactur/getListRffacturSaldoPendiente/';
  RFFACTUR_VALIDAR = 'Rffactur/validarRffactur/';
  RFFACTUR_GET_LIST_APLICADAS = 'Rffactur/getListRffacturAplicadas/';
  RFFACTUR_GET_PDF_ESTADOCUENTA = 'Rffactur/getPdfEstadoCuenta';
  RFFACTUR_GET_TOTAL_BY_MES_ANIO = 'Rffactur/getRffacturByMesAnio/';
  RFFACTUR_GET_LIST_BY_MES_ANIO = 'Rffactur/getListRffacturByMesAnio/';
  RFFACTUR_GET_IDFACTUR_BY_UUID_RFCEMISOR = 'Rffactur/getIdfacturByUuidRfcEmisor/';

  // TABLA RFAPLPAG
  RFAPLPAG_GET_LIST_BY_IDFACTUR = 'Rfaplpag/getListRfaplpagByIdfactur/';

  // TABLA RFFACFOL
  RFFACFOL_GET_LIST_BY_IDPERSON_IDTIPCOM = 'Rffacfol/getListRffacfolByIdpersonAndIdtipcom/';
  RFFACFOL_GET_BY_ID = 'Rffacfol/getRffacfolById/';

  // CFDI
  CFDI_TIMBRAR_RFFACTUR = 'Cfdi/timbrarRffactur/';
  CFDI_TIMBRAR_EMMOVIMI = 'Cfdi/timbrarEmmovimi/';
  CFDI_DOWNLOAD_FILES = 'Cfdi/downloadFiles/';
  CFDI_SEND_FACTURA = 'Cfdi/sendFactura/';
  CFDI_VALIDAR = 'Cfdi/validarCFDI/';
  CFDI_LISTADO = 'Cfdi/listadoCFDIS';
  CFDI_GET_RELACIONADO = 'Cfdi/getCFDIrelacionado/';
  CFDI_CANCELAR = 'Cfdi/cancelarCFDI';
  CFDI_CANTIDAD_TIMBRES = 'Cfdi/getCantidadTimbres/';
  CFDI_DOWNLOAD_ZIP = 'Cfdi/downloadZIP/';
  CFDI_NOTIFICAR_CANCELADO = 'Cfdi/notificarCanceladoCFDI/';
  CFDI_GET_ESTATUS_PERIODO_CANCELADO = 'Cfdi/getEstatusPeriodoCancelado/';
  CFDI_POST_SOLICITUD_CANCELADO = 'Cfdi/postSolicitudCancelado/';

  // TABLA EMTIPMOV
  EMPTIPMOV_GET_BY_IDPERSON_PAGO = 'Emtipmov/getEmtipmovByIdpersonPago/';
  EMPTIPMOV_GET_BY_IDPERSON_PAGO_CXP = 'Emtipmov/getEmtipmovByIdpersonPagoCXP/';

  // TABLA EMMOVIMI
  EMMOVIMI = 'Emmovimi';
  EMMOVIMI_GET_LIST_GENERAL = 'Emmovimi/getListEmmovimiGeneral';
  EMMOVIMI_GET_BY_IDMOVIMI = 'Emmovimi/getByIdmovimi/';
  EMMOVIMI_FILTER = 'Emmovimi/filterEmmovimi/';
  EMMOVIMI_GET_TOTAL_BY_MES_ANIO = 'Emmovimi/getTotalPagosByMesAnio/';
  EMMOVIMI_GET_LIST_BY_MES_ANIO = 'Emmovimi/getListEmmovimiByMesAnio/';
  EMMOVIMI_COUNT_POSTERIORES = 'Emmovimi/getCountEmmovimiPosteriores/';
  EMMOVIMI_RESTABLECER_APLICACION = 'Emmovimi/restablecerAplicacion/'

  // TABLA CPMOVIMI
  CPMOVIMI = 'Cpmovimi';
  CPMOVIMI_FILTER = 'Cpmovimi/filterCpmovimi';
  CPMOVIMI_FUSIONAR = 'Cpmovimi/fusionarPagos';
  CPMOVIMI_BY_ID = 'Cpmovimi/getCpmovimiById/';
  CPMOVIMI_ANTICIPOS_ACTIVOS = 'Cpmovimi/getAnticiposActivos/';
  CPMOVIMI_IMPRESO_SOLICITUD = 'Cpmovimi/getImpresoSolicitud/';
  CPMOVIMI_GET_PDF_SOLICITUD = 'Cpmovimi/getPdfSolicitud/';
  CPMOVIMI_REPORTE_DIAS = 'Cpmovimi/reporteDias';
  CPMOVIMI_CANCELAR = 'Cpmovimi/cancelarCpmovimi/';

  // TABLA INPATRIM
  INPATRIM = 'Inpatrim';
  INPATRIM_GET_LIST = 'Inpatrim/getListInpatrim/';
  INPATRIM_GET_LIST_GROUPBY_IDPERSON = 'Inpatrim/getListInpatrimGroupByIdperson';
  INPATRIM_GET_LIST_BY_IDPERSON_LOCAL = 'Inpatrim/getListInpatrimByIdpersonLocal/';
  INPATRIM_BY_ID = 'Inpatrim/getInpatrimById/';
  INPATRIM_GET_PDF = 'Inpatrim/getPdf';
  INPATRIM_GET_NUMERO_DOCUMENTOS_COMPRAVENTA = 'Inpatrim/getNumeroDocumentosCompraventa/';

  // TABLA LEACUSES
  LEACUSES = 'Leacuses';
  LEACUSES_FILTER = 'Leacuses/filterLeacuses';
  LEACUSES_BY_ID = 'Leacuses/getLeacusesById/';

  // TABLA INPATINM
  INPATINM = 'Inpatinm';
  INPATINM_GET_LIST_BY_IDPATRIM = 'Inpatinm/getListInpatinmByIdpatrim/';
  INPATINM_GET_NUMERO_DOCUMENTOS_COMPRAVENTA = 'Inpatinm/getNumeroDocumentosCompraventa/';


  // TABLA INPATPRO
  INPATPRO = 'Inpatpro';
  INPATPRO_GET_LIST_BY_IDPATRIM = 'Inpatpro/getListInpatproByIdpatrim/';
  INPATPRO_DELETE = 'Inpatpro/deleteInpatpro/';

  // TABLA UPPERMIS
  GET_PERMISOS_USUARIO = 'Uppermis/getPermisosUsuario/';
  UPPERMIS_GET_PERMISO_CONTROL_USUARIO = 'Uppermis/getPermisoControlUsuario/';

  // TABLA UPCONTRO
  GET_LIST_UPCONTRO_BY_IDPLUGIN_CHECK_USER = 'Upcontro/getListUpcontroByIdpluginCheckUser/';


  // TABLA PRESTATU
  PRESTATU_GET_LIST = 'Prestatu/getListPrestatu';

  // TABLA INSEGCLA
  INSEGCLA_GET_LIST = 'Insegcla/getListInsegcla';

  // TABLA GLASEGUR
  GLASEGUR = 'Glasegur';
  GLASEGUR_GET_LIST = 'Glasegur/getListGlasegur';
  GLASEGUR_GET_DATA_LIST = 'Glasegur/getDataList';

  // TABLA INTIPPOL
  INTIPPOL_GET_LIST = 'Intippol/getListIntippol';

  // TABLA INFREPAG
  INFREPAG_GET_LIST = 'Infrepag/getListInfrepag';

  // TABLA INVMARCA
  INVMARCA_GET_LIST = 'Invmarca/getListInvmarca';

  // TABLA INTIPTRA
  INTIPTRA_GET_LIST = 'Intiptra/getListIntiptra';

  // TABLA LILICTIP
  LILICTIP_GET_LIST = 'Lilictip/getListLilictip';

  // TABLA CTFACTIP
  CTFACTIP_GET_LIST = 'Ctfactip/getListCtfactip';

  // TABLA LILICENC
  LILICENC = 'Lilicenc';
  LILICENC_GET_LIST = 'Lilicenc/getListLilicenc';
  LILICENC_BY_ID = 'Lilicenc/getLilicencById/';

  // TABLA PREPAGOS
  PREPAGOS = 'Prepagos';
  PREPTATOS_GET_LIST = 'Prepagos/getListPrepagos/';
  PREPAGOS_BY_ID = 'Prepagos/getPrepagosById/';
  PREPAGOS_GET_PDF_SOLICITUD = 'Prepagos/getPDFSolicitudPago/';
  PREPAGOS_GET_LIST_ENVIO_PAGO = 'Prepagos/getListPrepagosEnvioPago/';
  PREPAGOS_GET_CONFIRMACION_COMPROBANTE_PAGO = 'Prepagos/getConfirmacionComprobantePago/';


  // TABLA CTCONPER
  CTCONPER = 'Ctconper';
  CTCONPER_GET_LIST_BY_IDCONDIC = 'Ctconper/getListCtconperByIdcondic/';

  // TABLA INSEGURO
  INSEGURO = 'Inseguro';
  INSEGURO_GET_LIST = 'Inseguro/getListInseguro/';
  INSEGURO_FILTER = 'Inseguro/filterInseguro/';
  INSEGURO_BY_ID = 'Inseguro/getInseguroById/';
  INSEGURO_GET_PDF = 'Inseguro/getPdf';
  INSEGURO_VALIDAR_ADJUNTOS_PAGOS = 'Inseguro/validarAdjuntosPagos/';

  // TABLA PSPROVEE
  PVPROVEE = 'Pvprovee';
  PVPROVEE_GET_LIST = 'Pvprovee/getListPvprovee';
  PVPROVEE_GET_LIST_ACTIVOS = 'Pvprovee/getListPvproveeActivos';
  PVPROVEE_VALIDAR_RFC = 'Pvprovee/validarRFC/';
  PVCTABAN_GET_LIST_BY_IDPROVEE_IDTIPMON = 'Pvctaban/getListPvctabanByIdtipmonIdperson/';
  PVPROVEE_BY_ID = 'Pvprovee/getPvproveeById/';

  // TABLA PSCTACON
  PSCTACON = 'Psctacon';
  PSCTACON_GET_LIST_BY_IDPERSON = 'Psctacon/getListPsctaconByIdperson/';
  PSCTACON_GET_BY_ID = 'Psctacon/getPsctaconById/';
  PSCTACON_EXISTE_CUENTA = 'Psctacon/getExisteCuenta/';

  // TABLA PSCLICON
  PSCLICON = 'Psclicon';
  PSCLICON_EXISTE_CUENTA = 'Psclicon/getExisteCuenta/';
  PSCLICON_GET_LIST_BY_IDPERSON = 'Psclicon/getListPscliconByIdperson/';
  PSCLICON_GET_BY_ID = 'Psclicon/getPscliconById/';

  // TABLA PVCTACON
  PVCTACON = 'Pvctacon';
  PVCTACON_EXISTE_CUENTA = 'Pvctacon/getExisteCuenta/';
  PVCTACON_GET_LIST_BY_IDPROVEE = 'Pvctacon/getListPvctaconByIdprovee/';
  PVCTACON_GET_BY_ID = 'Pvctacon/getPvctaconById/';

  // TABLA PVCTABAN
  PVCTABAN = 'Pvctaban';
  PVCTABAN_GET_LIST_BY_IDPROVEE = 'Pvctaban/getListPvctabanByIdprovee/';
  PVCTABAN_BY_ID = 'Pvctaban/getPvctabanById/';

  // TABLA PVCONTAC
  PVCONTAC = 'Pvcontac';
  PVCONTAC_GET_LIST_BY_IDPROVEE = 'Pvcontac/getListPvcontacByIdprovee/';
  PVCONTAC_BY_ID = 'Pvcontac/getPvcontacById/';
  PVCONTAC_GET_LIST_BY_IDPROVEE_ENVIOPAGOS = 'Pvcontac/getListPvcontacByIdproveeEnvioPagos/';

  // STOREPROCEDURE
  STORE_SPCXCESTADOCUENTA = 'Rffactur/postDataSpCxCEstadoCuenta';
  STORE_SPCXCANTIGUEDADSALDOS = 'Rffactur/postDataSpCxCAntiguedadDeSaldos';

  // TABLA USPREFER
  USPREFER = 'Usprefer';
  GET_PREFERENCIAS_USUARIO = 'Usprefer/getPreferenciasUsuario/';
  DELETE_PREFERENCIAS_USUARIO = 'Usprefer/deletePreferenciasUsuario/';


  // TABLA RQTIPART
  RQTIPART = 'Rqtipart';
  RQTIPART_GET_LIST = 'Rqtipart/getListRqtipart';

  // TABLA RQARTICU
  RQARTICU_GET_LIST = 'Rqarticu/getListRqarticu';
  RQARTICU_VALIDAR_ARTICULO = 'Rqarticu/validarArticulo/';
  RQARTICU_FIND_BY_ID = 'Rqarticu/findById/';

  // TABLA RQGENRAL
  RQGENRAL = 'Rqgenral';
  RQGENRAL_FILTER = 'Rqgenral/filterRqgenral';
  RQGENRAL_CANCEL = 'Rqgenral/cancelRqgenral/';
  RQGENRAL_SEND = 'Rqgenral/sendRqgenral/';
  RQGENRAL_GET_PDF_REQUISICION = 'Rqgenral/getPdfRequisicion/';
  RQGENRAL_GET_PDF_ODC = 'Rqgenral/getPdfODC/';
  RQGENRAL_BY_ID = 'Rqgenral/getRqgenralById/';

  // TABLA RQDETALL
  RQDETALL_GET_LIST_BY_IDGENRAL = 'Rqdetall/getListRqdetallByIdgenral/';
  RQDETALL_MARCAR = 'Rqdetall/marcarRqdetall/';

  // TABLA USDEPART
  USDEPART_GET_LIST = 'Usdepart/getListUsdepart';

  // TABLA SAMOTCAN
  SAMOTCAN_GET_LIST = 'Samotcan/getListSamotcan';

  // TABLA GLACTECO
  GLACTECO_GET_LIST = 'Glacteco/getListGlacteco';

  // TABLA GLGIROME
  GLGIROME_GET_LIST = 'Glgirome/getListGlgirome';

  // TABLA GLEDOCIV
  GLEDOCIV_GET_LIST = 'Gledociv/getListGledociv';

  // TABLA GLREGCON
  GLREGCON_GET_LIST = 'Glregcon/getListGlregcon';

  // TABLA GLTIPIDE
  GLTIPIDE_GET_LIST = 'Gltipide/getListGltipide';

  // TABLA GLADMSOC
  GLADMSOC_GET_LIST = 'Gladmsoc/getListGladmsoc';

  // TABLA GLTIPTER
  GLTIPTER_GET_LIST = 'Gltipter/getListGltipter';

  // TABLA GLTIPINM
  GLTIPINM_GET_LIST = 'Gltipinm/getListGltipinm';

  // TABLA EMPAGEST
  EMPAGEST_GET_LIST = 'Empagest/getListEmpagest';

  // TABLA GLTIPIMP
  GLTIPIMP_GET_LIST = 'Gltipimp/getListGltipimp';

  // TABLA RFTIPOPE
  RFTIPOPE_GET_LIST = 'Rftipope/getListRftipope';

  // TABLA GLPROYEC
  GLPROYEC_GET_LIST = 'Glproyec/getListGlproyec';

  // TABLA PSEMPUSU
  PSEMPUSU = 'Psempusu';
  PSEMPUSU_GET_LIST_BY_IDUSUARI = 'Psempusu/getListPsempusuByIdusuari';
  PSEMPUSU_GET_LIST_ACTIVE_FOR_IDUSUARI = 'Psempusu/getListPsempusuActiveForIdusuari/';

  // TABLA UPPERAUX
  UPPERAUX = 'Upperaux';

  // TABLA GLRECPAG
  GLRECPAG_GET_LIST = 'Glrecpag/getListGlrecpag';

  // TABLA GLTIPCOM
  GLTIPCOM_GET_LIST = 'Gltipcom/getListGltipcom';

  // TABLA UPPLUGIN
  UPPLUGIN_GET_LIST = 'Upplugin/getListUpplugin';

  // TABLA CGGASTIP
  CGGASTIP_GET_LIST = 'Cggastip/getListCggastip';

  // TABLA CGESTATU
  CGESTATU_GET_LIST = 'Cgestatu/getListCgestatu';

  // TABLA LETIPACT
  LETIPACT_GET_LIST = 'Letipact/getListLetipact';

  // TABLA LETIPPER
  LETIPPER_GET_LIST = 'Letipper/getListLetipper';

  // TABLA GLTIPOPE
  GLTIPOPE_GET_LIST = 'Gltipope/getListGltipope';

  // TABLA USCUEBAN
  USCUEBAN_GET_LIST_BY_IDUSUARI = 'Uscueban/getListUscuebanByIdusuari/';

  // TABLA CPFACTUR
  CPFACTUR_XML = 'Cpfactur/lecturaXML';
  CPFACTUR_CPFACTUR_EXTRANJERA = 'Cpfactur/postCpfacturExtranjera';
  CPFACTUR_GET_LIST_BY_IDGENRAL = 'Cpfactur/getListCpfacturByIdgenral/';
  CPFACTUR_DELETE = 'Cpfactur/deleteCpfactur/';
  CPFACTUR_FILTER = 'Cpfactur/filterCpfactur';
  CPFACTUR_SET_USUARIO_VALIDA = 'Cpfactur/setUsuarioValida/';
  CPFACTUR_GET_LIST_SALDO_PENDIENTE = 'Cpfactur/getListCpfacturSaldoPendiente/';
  CPFACTUR_GET_LIST_SALDO_PENDIENTE_A_PAGAR = 'Cpfactur/getListCpfacturSaldoPendienteAPagar/';
  CPFACTUR_GET_LIST_APLICADAS = 'Cpfactur/getListCpfacturAplicadas/';

  // TABLA CGGASTOS
  CGGASTOS = 'Cggastos';
  CGGASTOS_FILTER = 'Cggastos/filterCggastos';
  CGGASTOS_BY_ID = 'Cggastos/getCggastosById/';
  CGGASTOS_CAMBIO_ESTATUS = 'Cggastos/setCambioEstatus/';
  CGGASTOS_DOWNLOAD_ZIP = 'Cggastos/downloadZIP/';

  // TABLA CGGASDET
  CGGASDET = 'Cggasdet';
  CGGASDET_GET_LIST_BY_IDGASTOS = 'Cggasdet/getListCggasdetByIdgastos/';
  CGGASDET_GET_EXISTE_FACTURA = 'Cggasdet/getExisteFactura/';

  // TABLA USBUSCAR
  USBUSCAR = 'Usbuscar';
  USBUSCAR_GET_LIST_BY_IDUSUARI = 'Usbuscar/getListUsbuscarByIdusuari/';

  // TABLA USLOGACC
  USLOGACC_GET_LIST = 'Uslogacc/getListUslogacc';

  // Consumo Servicio CONPAQI
  CONTPAQI = 'Contpaqi';

  // PLD
  PLD_GET_REPORT = 'Pld/getPldReport/';
  PLD_GET_LIST_CONTRA_BY_ID_PERSON = 'Pld/getListCtContraByIdpersonLocal/';

  // NOTAS
  NOTAS = 'Notas';

  // REPORTES BIRT
  GENERAR_REPORTE_BIRT = 'Birt';


  // SPOTLIGH
  SPOTLIGHT_CHECK = 'Spotlight';


  // GRAFICOS
  GRAFICOS_FACTURACION_MENSUAL = 'Graficos/facturacionMensual/';
  GRAFICOS_PAGOS_MENSUAL = 'Graficos/pagosMensual/';
  GRAFICOS_CONSUMO_MENSUAL_TIMBRADO = 'Graficos/consumoMensualTimbrado/';
  GRAFICOS_REQUISICIONES_BY_DEPTO = 'Graficos/requisicionesByDepto/';
  GRAFICOS_TIPO_CAMBIO_DIARIO_MENSUAL = 'Graficos/tipoCambioDiarioMensual/';
  GRAFICOS_PAGOS_MENSUAL_CXP = 'Graficos/pagosMensualCxp/';
  GRAFICOS_METODOS_PAGO_CXC = 'Graficos/metodosPagoCxc/';
  GRAFICOS_USO_CFDI_CXC = 'Graficos/usoCFDICxc/';
  GRAFICOS_FORMAS_PAGO_CXC = 'Graficos/formasPagoCxc/';

}
